import { render, staticRenderFns } from "./packageCourseCard.vue?vue&type=template&id=4ff3019b&scoped=true&"
import script from "./packageCourseCard.vue?vue&type=script&lang=js&"
export * from "./packageCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./packageCourseCard.vue?vue&type=style&index=0&id=4ff3019b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3019b",
  null
  
)

export default component.exports